import dayjs from 'dayjs';

import type {ConferenceApiModel} from '../../../api/conference';
import type {CourseApiModel} from '../../../api/course';
import type {Nullable} from '../../utility-types';

import {datetimeObjToISOString} from '../../datetime';
import {envManager} from '../../env';
import {isDefined} from '../../typecheck';
import {isCourseCorporate} from '../course';

type ConferenceApiModelWithCourse = ConferenceApiModel & {
  course?: Nullable<CourseApiModel>;
};

export const isConferenceRescheduleEnabled = (
  conference?: Nullable<ConferenceApiModelWithCourse>,
) => {
  if (isDefined(conference)) {
    return envManager.isB2b ? b2bCheck(conference) : coreCheck(conference);
  }

  return false;
};

const coreCheck = (conference: ConferenceApiModelWithCourse) => {
  if (isCourseCorporate(conference.course)) {
    return b2bCheck(conference);
  }

  const isNotPast = conference.status !== 'past';

  return isNotPast;
};

const b2bCheck = (conference: ConferenceApiModelWithCourse) => {
  const isMoreThan24hBeforeStart = dayjs().isBefore(
    dayjs(datetimeObjToISOString(conference.start_date))
      .subtract(24, 'hours')
      .startOf('hour'),
  );

  const isNotPast = conference.status !== 'past';

  return isMoreThan24hBeforeStart && isNotPast;
};
